<template>
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 125" xml:space="preserve">
        <g>
            <path
                fill="#ffc043"
                class="st0"
                d="M22.8,94.4c-1.9,0-3.5-2-3.5-4.4c0-0.8-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5c0,2.4-1.6,4.4-3.5,4.4
		c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5c1.9,0,3.5,2,3.5,4.4c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5
		c0-2.4,1.6-4.4,3.5-4.4c0.8,0,1.5-0.7,1.5-1.5C24.3,95,23.6,94.4,22.8,94.4z"
            />
            <path
                fill="#ffc043"
                class="st0"
                d="M88,61C67.3,61,50.4,41,50.4,16.5c0-0.8-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5C47.4,41,30.5,61,9.7,61
		c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5c20.7,0,37.6,19.9,37.6,44.4c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5
		C50.4,84,67.3,64,88,64c0.8,0,1.5-0.7,1.5-1.5C89.6,61.7,88.9,61,88,61z"
            />
            <path
                fill="#ffc043"
                class="st0"
                d="M90.3,27.3c-3.5,0-6.4-3.5-6.4-7.8c0-0.8-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5c0,4.3-2.9,7.8-6.4,7.8
		c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5c3.5,0,6.4,3.5,6.4,7.8c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5
		c0-4.3,2.9-7.8,6.4-7.8c0.8,0,1.5-0.7,1.5-1.5C91.8,28,91.1,27.3,90.3,27.3z"
            />
        </g>
    </svg>
</template>
